import { ConfigProvider } from 'antd';

// antd v5 uses CSS-in-JS and ships no bundled stylesheet, but it still
// expects the global reset that v4's antd/dist/antd.css used to carry
// (box-sizing, heading and list margins, etc). Must precede ./index.css,
// which overrides the reset's font-family and body sizing.
import 'antd/dist/reset.css';

import React from 'react';
import ReactDOM from 'react-dom';

import { installDragBackstop } from 'utils/DragHelper';

import App from './App';

import './index.css';

const FONT_FAMILY = 'var(--adhub-font-family, sans-serif)';
const THEME = { token: { fontFamily: FONT_FAMILY } };

// Static message.*/notification.* render into their own detached React root and
// so never see the provider below. They do read this global, which
// antd/lib/message/index.js pulls via globalConfig().getTheme().
ConfigProvider.config({ theme: THEME });

function reportBuildInfo() {
  const logPrefix = '[Build info]';
  const buildInfoEl = window.document.querySelector('meta[name="buildinfo"]');
  if (!buildInfoEl) {
    console.warn(`${logPrefix} no element`);
    return;
  }
  const buildInfoAttr = buildInfoEl.getAttribute('content');
  if (!buildInfoAttr) {
    console.warn(`${logPrefix} no content attribute`);
    return;
  }
  const [commit, _branch, _buildTime, _builder, _buildNode] =
    buildInfoAttr.split(' ');
  console.log(`${logPrefix} commit ${commit}`);
}

function start() {
  const root = window.document.getElementById('root');
  if (!root) {
    throw new Error('Root element not found');
  }
  // Must wrap here rather than inside App, which early-returns for the
  // FRAMELESS and NONE view modes -- a provider placed inside it would
  // miss the Tearsheet path.
  ReactDOM.render(
    <ConfigProvider theme={THEME}>
      <App />
    </ConfigProvider>,
    root
  );
}

function main() {
  reportBuildInfo();
  // Before start(): a component mounting a dragHelper depends on this
  // having run, since an uncanceled dragover means the browser never fires
  // drop.
  installDragBackstop();
  start();
}

main();
